import type { FormItemRule } from 'naive-ui'

// 与后端 RegularUtils.isIDNumber 保持一致：仅接受 18 位，且第 18 位校验码必须正确
const ID_CARD_REGEX = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
// 前十七位加权因子
const ID_CARD_WEIGHTS = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
// 除以 11 后余数对应的校验码
const ID_CARD_CHECK_CODES = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

/** 校验身份证号是否合法 */
export function isValidIdCard(value: string): boolean {
  if (!value || !ID_CARD_REGEX.test(value)) {
    return false
  }
  const chars = value.toUpperCase().split('')
  let sum = 0
  for (let i = 0; i < ID_CARD_WEIGHTS.length; i++) {
    sum += Number(chars[i]) * ID_CARD_WEIGHTS[i]
  }
  return ID_CARD_CHECK_CODES[sum % 11] === chars[17]
}

export default {
  empty: [
    {
      required: false,
    },
  ],
  required: [
    {
      type: 'string',
      required: true,
      message: '必填项',
      trigger: ['blur', 'change'],
    },
  ],
  anyRequired: [
    {
      required: true,
      message: '必填项',
      trigger: ['blur', 'change'],
      validator(_rule: any, value: any) {
        return value !== null && value !== undefined && value !== ''
      },
    },
  ],
  arrayRequired: [
    {
      type: 'array',
      required: true,
      message: '必填项',
      trigger: ['blur', 'change'],
    },
  ],
  numberRequired: [
    {
      type: 'number',
      required: true,
      message: '必填项',
      trigger: ['blur', 'change'],
    },
  ],
  booleanRequired: [
    {
      type: 'boolean',
      required: true,
      message: '必填项',
      trigger: ['blur', 'change'],
    },
  ],
  idCard: [
    {
      required: true,
      trigger: ['blur', 'input'],
      validator(_rule: any, value: any) {
        const val = value === null || value === undefined ? '' : `${value}`.trim()
        if (!val) {
          return new Error('请输入身份证号码')
        }
        return isValidIdCard(val) || new Error('身份证号码格式不正确')
      },
    },
  ],
} as {
  empty: FormItemRule[]
  required: FormItemRule[]
  anyRequired: FormItemRule[]
  arrayRequired: FormItemRule[]
  numberRequired: FormItemRule[]
  booleanRequired: FormItemRule[]
  idCard: FormItemRule[]
}
